import { render, staticRenderFns } from "./ApartmentsList.vue?vue&type=template&id=3cfef146&scoped=true"
import script from "./ApartmentsList.vue?vue&type=script&lang=js"
export * from "./ApartmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfef146",
  null
  
)

export default component.exports